/**
 * API Service for E-Commerce Analytics
 * Handles all backend API calls
 */

import axios from 'axios';

// Base URL for the API
const API_BASE_URL = 'https://ecommerce-api-398354112983.us-central1.run.app';

// Create axios instance with default config
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// API endpoints
const apiService = {
  /**
   * Feature 1: Get sales funnel data
   */
  getSalesFunnel: async () => {
    try {
      const response = await api.get('/api/sales-funnel');
      return response.data;
    } catch (error) {
      console.error('Error fetching sales funnel:', error);
      throw error;
    }
  },

  /**
   * Feature 2: Get top converting products
   * @param {number} limit - Number of products to return
   */
  getTopProducts: async (limit = 20) => {
    try {
      const response = await api.get(`/api/products/top-converting?limit=${limit}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching top products:', error);
      throw error;
    }
  },

  /**
   * Feature 3: Get abandoned cart products
   * @param {number} limit - Number of products to return
   */
  getAbandonedCarts: async (limit = 20) => {
    try {
      const response = await api.get(`/api/products/abandoned-carts?limit=${limit}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching abandoned carts:', error);
      throw error;
    }
  },

  /**
   * Feature 4: Get session analytics
   */
  getSessionAnalytics: async () => {
    try {
      const response = await api.get('/api/sessions/analytics');
      return response.data;
    } catch (error) {
      console.error('Error fetching session analytics:', error);
      throw error;
    }
  },

  /**
   * Feature 5: Get brand trends
   * @param {string} brand - Brand name
   * @param {string} startDate - Start date (YYYY-MM-DD)
   * @param {string} endDate - End date (YYYY-MM-DD)
   */
  getBrandTrends: async (brand, startDate = null, endDate = null) => {
    try {
      let url = `/api/brands/trends?brand=${encodeURIComponent(brand)}`;
      if (startDate) url += `&start_date=${startDate}`;
      if (endDate) url += `&end_date=${endDate}`;
      
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching brand trends:', error);
      throw error;
    }
  },

  /**
   * Health check
   */
  healthCheck: async () => {
    try {
      const response = await api.get('/');
      return response.data;
    } catch (error) {
      console.error('Error in health check:', error);
      throw error;
    }
  },
};

export default apiService;
